import React from "react";
import '../Common.scss';
import PageTable from '../../../components/PageTable';
const headerList=["Module Code","Module Description","Dimension","Accessory details", "Handle Details"]//"Module Description"
const valuesKey=[ "moduleAnnotation","name","moduleDimension","accessoryDetails", "handleDetails"] //"moduleDescription"

export default class Appliances extends React.Component<any, any>{
    
    render() {
        const { pageDetails} = this.props;
        const {moduleList} = pageDetails || {};
        let subCategories;
        if(moduleList){
            subCategories=Object.keys(moduleList);
        }
        return (  
        <div>
        <div className="page-heading">{pageDetails?.name}</div>
        {
            subCategories && subCategories.map(key => <PageTable tableName={moduleList[key] ? `${moduleList[key][0]['subcategoryName']} (${(moduleList[key][0]?.custom && moduleList[key][0]?.customType !== "NA") ? moduleList[key][0]?.customType : moduleList[key][0]["zoneName"]})` : null} headerList={headerList} valuesKey={valuesKey} valuesList={moduleList[key]} moduleList={true}></PageTable>)
        }  
        </div>

        )
    }

}